export const SPECIALISATION_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    icon: "/images/icon.png",
    hover_icon: "/images/hover-icon.png",
    card_color: "#FFFFFF",
    card_hover_color: "#F5F5F5",
    card_title_color: "#000000",
    card_title_hover_color: "#000000",
    mobile_card_title_color: "#000000",
    card_title: "Sample Specialisation",
    card_description_color: "#666666",
    card_description_hover_color: "#666666",
    mobile_card_description_color: "#FFFFFF",
    card_cta_text: "Learn More",
    card_cta_text_color: "#F74958",
    text: "Sample description text",
    priority: 1,
  },

  SPECIALISATION_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Specialisation Title",
      value: "Specialisations Available",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Specialisation Title",
      required: false,
      defaultValue: "Specialisations Available",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "cta_text",
      label: "CTA Text",
      value: "Load More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA Text",
      required: false,
      defaultValue: "Load More",
    },
    {
      fieldName: "cta_text_color",
      label: "CTA Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "cta_background_color",
      label: "CTA Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_icon",
      label: "CTA Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload CTA Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_icon_alt",
      label: "CTA Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for CTA icon",
      required: false,
      defaultValue: "Load more",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Specialisation Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Specialisation",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Icon",
      required: true,
    },
    {
      header: "Icon Alt Text",
      fieldName: "alt_icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Text for Icon",
      required: false,
    },
    {
      header: "Hover Icon",
      fieldName: "hover_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Hover Icon",
      required: false,
    },
    {
      header: "Card Color",
      fieldName: "card_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Card Color",
      required: false,
    },
    {
      header: "Card Hover Color",
      fieldName: "card_hover_color",
      value: "#F5F5F5",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Card Hover Color",
      required: false,
    },
    {
      header: "Card Title Color",
      fieldName: "card_title_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Card Title Color",
      required: false,
    },
    {
      header: "Card Title",
      fieldName: "card_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Card Title",
      required: true,
    },
    {
      header: "Card Title Hover Color",
      fieldName: "card_title_hover_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Card Title Hover Color",
      required: false,
    },
    {
      header: "Mobile Card Title Color",
      fieldName: "mobile_card_title_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Mobile Card Title Color",
      required: false,
    },
    {
      header: "Card description Color",
      fieldName: "card_description_color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Card Description Color",
      required: false,
    },
    {
      header: "Description",
      fieldName: "text",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description Text",
      required: true,
    },
    {
      header: "Card Description Hover Color",
      fieldName: "card_description_hover_color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Card Description Hover Color",
      required: false,
    },
    {
      header: "Mobile Card Description Color",
      fieldName: "mobile_card_description_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Mobile Card Description Color",
      required: false,
    },
    {
      header: "Card CTA Text (mobile)",
      fieldName: "card_cta_text",
      value: "Learn More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Learn More",
      required: false,
    },
    {
      header: "Card CTA Text Color (mobile)",
      fieldName: "card_cta_text_color",
      value: "#F74958",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Color for mobile card CTA link",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
  ],
};

